import styled, { css } from 'styled-components';
import { breakpoints } from 'theme';

export const StyledEditorWrapper = styled.div<{ $fill?: boolean }>`
  position: relative;

  ${({ $fill }) =>
    $fill &&
    css`
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
    `}
`;

export const StyledEditable = styled.div<{ $fill?: boolean }>`
  min-height: 220px;
  ${({ $fill }) =>
    $fill &&
    css`
      flex: 1 1 auto;
    `}
  outline: none;
  text-align: left;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.65;
  color: ${({ theme }) => theme.color.pickledBluewood};
  word-break: break-word;
  overflow-wrap: anywhere;
  cursor: text;
  caret-color: ${({ theme }) => theme.color.brightTurquoise};

  &::selection,
  & *::selection {
    background: ${({ theme }) => `${theme.color.brightTurquoise}59`};
    color: ${({ theme }) => theme.color.pickledBluewood};
  }

  & a {
    color: ${({ theme }) => theme.color.brightTurquoise};
    text-decoration: underline;
  }

  @media ${breakpoints.downSmPlus} {
    min-height: 180px;
    font-size: 14px;
  }
`;

export const StyledPlaceholder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  font-size: 15px;
  line-height: 1.65;
  color: ${({ theme }) => theme.color.casper};
  pointer-events: none;
  user-select: none;

  @media ${breakpoints.downSmPlus} {
    font-size: 14px;
  }
`;

export const StyledToolbar = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2px;
  margin-top: auto;
  margin-left: calc(var(--composer-pad) * -1);
  margin-right: calc((var(--composer-pad) - var(--composer-scrollbar)) * -1);
  padding: 30px var(--composer-pad) 6px;
  border-top: none;
  background: linear-gradient(
    to bottom,
    transparent 24px,
    ${({ theme }) => theme.color.white} 24px
  );
  pointer-events: none;

  & > * {
    pointer-events: auto;
  }

  &::before {
    content: '';
    position: absolute;
    top: 24px;
    right: 0;
    left: 0;
    border-top: 1px solid ${({ theme }) => theme.color.porcelain};
  }
`;

export const StyledToolbarButton = styled.button<{ active?: boolean }>`
  display: inline-flex;
  flex: 0 0 32px;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  color: ${({ theme }) => theme.color.BlueBayoux};
  background: transparent;
  transition: background 0.12s ease, color 0.12s ease;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    background: ${({ theme }) => theme.color.blackSqueeze};
    color: ${({ theme }) => theme.color.pickledBluewood};
  }

  ${({ active, theme }) =>
    active &&
    css`
      color: ${theme.color.brightTurquoise};
      background: ${theme.color.brightTurquoise}1F;

      &:hover {
        color: ${theme.color.skobeloffGreen};
        background: ${theme.color.brightTurquoise}2E;
      }
    `}

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.brightTurquoise};
    outline-offset: -2px;
  }
`;

export const StyledToolbarDivider = styled.span`
  flex: 0 0 1px;
  width: 1px;
  height: 16px;
  margin: 0 6px;
  background: ${({ theme }) => theme.color.porcelain};
`;

export const StyledLinkForm = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const StyledLinkInput = styled.input<{ invalid?: boolean }>`
  width: 240px;
  height: 32px;
  padding: 0 10px;
  border: 1px solid
    ${({ invalid, theme }) =>
      invalid ? theme.color.bittersweet : theme.color.porcelain};
  border-radius: 8px;
  outline: none;
  font-size: 13px;
  color: ${({ theme }) => theme.color.pickledBluewood};
  background: ${({ theme }) => theme.color.white};

  &:focus {
    border-color: ${({ theme }) => theme.color.brightTurquoise};
  }

  &::placeholder {
    color: ${({ theme }) => theme.color.casper};
  }

  @media ${breakpoints.downSmPlus} {
    width: 180px;
  }
`;
